import { Alert } from "reactstrap";

export const Alerts = ({
  hasOrganization,
  defaultValues,
  existingOrganization,
  translate,
}) => (
  <>
    {existingOrganization && (
      <Alert color="info" className="mt-2">
        {translate("projectUnitAssociatedTo")}
        <strong>{existingOrganization.description}</strong>
      </Alert>
    )}

    {hasOrganization && !defaultValues.organization?.id && (
      <Alert color="danger">
        Impossibile associare un'altra unità all'organizzazione
      </Alert>
    )}
  </>
);
